// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zcp-drag-cursor{cursor:pointer;position:absolute;width:8px;height:8px;border-radius:8px;border:2px solid #fff;box-shadow:0px 0px 1px 1px #333;z-index:1;box-sizing:border-box;pointer-events:none}", ""]);
// Exports
module.exports = exports;
